import { Button } from "@justhome/react-ui";
import { FC } from "react";

interface ApplicationHeaderNavProps {
  onContactClick?: VoidFunction;
}

const ApplicationHeaderNav: FC<ApplicationHeaderNavProps> = ({
  onContactClick,
}) => {
  const showButton = !!onContactClick;

  return (
    <nav className="flex gap-3xs m:gap-3xs items-center ml-auto m:h-2m pb-2xs">
      {showButton && (
        <Button variant="primary" size="sm" onClick={onContactClick}>
          <span className="hidden s:block">Kostenfrei beraten lassen</span>
          <span className="s:hidden">Beratung</span>
        </Button>
      )}
    </nav>
  );
};

export default ApplicationHeaderNav;
